import { render } from "./PosPurchaseReturn.vue?vue&type=template&id=30808665&scoped=true&ts=true"
import script from "./PosPurchaseReturn.vue?vue&type=script&lang=ts"
export * from "./PosPurchaseReturn.vue?vue&type=script&lang=ts"

import "./PosPurchaseReturn.vue?vue&type=style&index=0&id=30808665&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30808665"]])

export default __exports__